<template>
  <div id='app'>
    <comheader></comheader>
    <div class="lf ks_right" id="rmodel">
      <comtop></comtop>
      <el-main >
          <div class="com_topaside">
            <span>培训<b>></b></span>
            <span>考试管理<b>></b></span>
            <span>试题管理<b>></b></span>
            <span>题库详情<b></b></span>
          </div>
          <div class="com_import">
              <span>{{title}}</span>
          </div>
          <div class="com_typography">
          <el-input placeholder="请输入内容" v-model="input" class="com_search lf" @change='searchtxt'><i slot="prefix" class="el-input__icon el-icon-search"></i></el-input>  
          <el-button type="primary" class="add_exam" icon="el-icon-plus" @click="hrefTo">新建试题</el-button>
          <div class="com_view lf">
            <span @click="delexam(0)">删除</span>
            <span @click="dialogMove">移动</span>
          </div>
          <el-checkbox v-model="checked" class="rf com_checked">只看我创建的</el-checkbox>
          <el-select v-model="value" placeholder="请选择" class="rf cascaderV"  @change="selectC" clearable >
            <el-option label="单选题" value="1"></el-option>
            <el-option label="多选题" value="5"></el-option>
            <el-option label="判断题" value="2"></el-option>
            <el-option label="填空题" value="3"></el-option>
            <!-- <el-option label="简答题" value="4"></el-option> -->
          </el-select>    
          </div>
      </el-main>
      <el-main class="exam_wrap exam_detail">
        <el-table :data="DataList" border style="width: 100%" class="exam_table"
          @selection-change="handleSelectionChange" ref="multipleTable"
        >
        <el-table-column
          type="selection"
          width="80">
          </el-table-column>
        <el-table-column
            v-for="info in tHeadr" :key="info.key"     
            :property="info.key"
            :label="info.label"
            :width="info.width"
        >
          <template slot-scope="scope">
              {{scope.row[scope.column.property]}}  <!-- 渲染对应表格里面的内容 -->
          </template>
          </el-table-column>
          <el-table-column label="操作">
            <template slot-scope="scope" class="exam_btn">
              <el-button @click="handleClick(scope)" type="text" size="large">编辑</el-button>
              <el-button type="text" size="large" @click="delexam(1,scope.$index,scope.row.q_id)" class="exam_delbtn" >删除</el-button>
            </template>
          </el-table-column>
        </el-table>
         <page :count="count" :curpage.sync='page' @pagenation='pagetion' ></page>
      </el-main>
    </div>
    <el-dialog title="移动" :visible.sync="dialogFormVisible" custom-class="dialog_move">
        <span>移动至：</span>
        <el-select v-model="region">
          <el-option :label="item.model_name" :value="item.e_id" v-for="(item,index) in moveList" :key="index"></el-option>
        </el-select>
        <div slot="footer" class="dialog-footer">
          <el-button type="primary" @click="moveExam">确 定</el-button>
          <el-button @click="dialogFormVisible = false">取 消</el-button>
        </div>
    </el-dialog>
  </div>
</template>
<style>
  .exam_detail .exam_table td:nth-child(2){
    text-align:left
  }
</style>
<script>
import comheader from './Common/comheader'
import comtop from './Common/comtop'
import page from './Common/page'
export default {
  inject:["reload"],
  name: 'detail',
  data () {
    return {
      show: true,
      dialogFormVisible:false,
      input:'',
      multipleSelection:'',
      checked:'',
      value:'',
      title:'',
      moveList:[],
      id:this.$route.query.id,
      url:this.HOME,
      region:'',
      DataList:[],
      limit:10, //一页几条数据
      count:0, //数据总计
      page:1, //当前页数
      tHeadr: [
        {
            label: '题目',
            key: 'questions',
            width:'658'
        },
        {
            label: '知识点',
            key: 'knowledge',
            width:'239'
        },
        {
            label: '难易程度',
            key: 'level',
            width:'125'
        },
        {
            label:'创建时间',
            key:'time',
            width:'175'
        },
        {
            label:'创建人',
            key:'create_name',
            width:'119'
        },
        ],
    }
  },
  components:{
    comheader,
    comtop,
    page
  },
  methods:{
   handleSelectionChange(val) {
        this.multipleSelection = val;
          let arr = [];
          for (let i in this.multipleSelection) {
            arr.push(this.multipleSelection[i].q_id);
          }
      },
    delexam(type,i,id){
      var btn = document.getElementsByClassName('exam_delbtn')
      if(type==1){
        var data={
          service:'Question.QsnDel',
          id:id,
          userid:localStorage.getItem('userid')
          }
        }
      else{
        if(this.multipleSelection==''){
          this.alertView.failView('请选择需要删除的试题')
          return false
        }
        var arr=[]
        for (let i in this.multipleSelection) {
            arr.push(this.multipleSelection[i].q_id);
        }
        var data={
          service:'Question.QsnDel',
          id:arr.toString(),
          userid:localStorage.getItem('userid')
          }
        }
      
        const h = this.$createElement;
        this.$msgbox({
          title: '消息',
          message: h('p', null, [
            h('span', null, '是否确定删除')
          ]),
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          showCancelButton:true,
          lockScroll:false,
          showClose:false,
          customClass:'delBtn',
        }).then(action => {
            this.$axios.post(this.url,this.$qs.stringify(data))
            .then(res=>{
              this.DataList.filter(item => item != i);
              this.alertView.successView('删除成功')
              this.dialogAdd = false
              this.reload()
            })
          
        });
    },
    hrefTo(){
      this.$router.push({ path:'/addexam/sign',query:{q_id:this.id}})
    },
    dialogMove(){
      if(this.multipleSelection==''){
        this.alertView.failView('请选择需要移动的试题')
        return false
      }
      else{
        this.dialogFormVisible=true
      }
    },
    moveExam(){
      if(this.region==''){
        this.alertView.failView('请选择要移动的题库')
      }
      else{
      var arr=[]
      for (let i in this.multipleSelection) {
          arr.push(this.multipleSelection[i].q_id);
      }
      var data={
        service:'Examination.Qsnmove',
        e_id:this.region,
        q_id:arr.toString()
      }
      this.$axios.post(this.HOME,this.$qs.stringify(data))
      .then(res=>{
        this.alertView.successView('移动成功')
        this.reload()
      })
      }
    },
    handleClick(val){
      var id = val.row.q_id
      if(val.row.q_type==1){
        var routeUrl = this.$router.resolve({ path:'/addexam/sign',query: {id:id,q_id:this.id}})
      }
      else if(val.row.q_type==2){
        var routeUrl = this.$router.resolve({ path:'/addexam/tfai',query: {id:id,q_id:this.id}})
      }
      else if(val.row.q_type==3){
        var routeUrl = this.$router.resolve({ path:'/addexam/exercise',query: {id:id,q_id:this.id}})
      }
      else if(val.row.q_type==4){
        var routeUrl = this.$router.resolve({ path:'/addexam/questions',query: {id:id,q_id:this.id}})
      }
      else if(val.row.q_type==5){
        var routeUrl = this.$router.resolve({ path:'/addexam/mcq',query: {id:id,q_id:this.id}})
      }
       window.open(routeUrl .href, '_blank');
    },
    pagetion(limit,page){
        var q_type=''
        const userid = localStorage.getItem('userid')
        var data={service:'Examination.ExamInfo',id:this.id,limit:limit,page:page,q_type:this.value, userid}
        console.log(data)
        var dataList=[]
        var url =this.url
        this.page =page 
        this.DataList=[]
        this.$axios.post(url,this.$qs.stringify(data))
        .then(res=>{
        this.count=parseInt(res.data.data.count)
          for(let i=0 ;i <res.data.data.info.length;i++){
            dataList.push(res.data.data.info[i])
            if(res.data.data.info[i].level==1){
              var levelTxt='简单'
            }
            else if(res.data.data.info[i].level==2){
              var levelTxt='一般'
            }
            else if(res.data.data.info[i].level==3){
              var levelTxt='较难'
            }
            else{
              var levelTxt='困难'
            }
            dataList[i].level=levelTxt
          }
          this.DataList=dataList
        })
          .catch(function (error) { // 请求失败处理
            console.log(error)
        });   
      },
      selectC(e){
         
        
        if(e!=''){
          this.page = 1
          console.log('999')
          var data={service:'Examination.ExamInfo',id:this.id,q_type:e,limit:10,page:1,userid:localStorage.getItem('userid')}
          var List=[]
          var url =this.url
          this.$axios.post(url,this.$qs.stringify(data))
          .then(res=>{
            if(res.data.data.info){
              this.count=parseInt(res.data.data.count)
            }
            if(res.data.data.code==0){
              for(let i=0 ;i <res.data.data.info.length;i++){
                List.push(res.data.data.info[i])
                if(res.data.data.info[i].level==1){
                  var levelTxt='简单'
                }
                else if(res.data.data.info[i].level==2){
                  var levelTxt='一般'
                }
                else if(res.data.data.info[i].level==3){
                  var levelTxt='较难'
                }
                else{
                  var levelTxt='困难'
                }
                List[i].level=levelTxt
              }
            }
            else{
              List=[]
            }
            this.DataList=List
          })
            .catch(function (error) { // 请求失败处理
              console.log(error)
          });
        }
        else{
          var data={service:'Examination.ExamInfo',id:this.id,limit:this.limit,page:this.page,userid:localStorage.getItem('userid')}
          var List=[]
          var url =this.url
          this.$axios.post(url,this.$qs.stringify(data))
          .then(res=>{
            if(res.data.data.info){
              this.count=parseInt(res.data.data.count)
            }
            for(let i=0 ;i <res.data.data.info.length;i++){
              List.push(res.data.data.info[i])
              if(res.data.data.info[i].level==1){
                var levelTxt='简单'
              }
              else if(res.data.data.info[i].level==2){
                var levelTxt='一般'
              }
              else if(res.data.data.info[i].level==3){
                var levelTxt='较难'
              }
              else{
                var levelTxt='困难'
              }
              List[i].level=levelTxt
            }
            this.DataList=List
          })
            .catch(function (error) { // 请求失败处理
              console.log(error)
          });
        }
      },
      searchtxt(){
        var dataList =[]
        this.comview.search(this.HOME,{service:'Examination.ExamInfo',where:this.input,id:this.id0,userid:localStorage.getItem('userid')},function(res,Message){
            if(res.data.data.code==0){
              for(let i=0 ;i <res.data.data.info.length;i++){
                dataList.push(res.data.data.info[i])
                if(res.data.data.info[i].level==1){
                  var levelTxt='简单'
                }
                else if(res.data.data.info[i].level==2){
                  var levelTxt='一般'
                }
                else if(res.data.data.info[i].level==3){
                  var levelTxt='较难'
                }
                else{
                  var levelTxt='困难'
                }
                dataList[i].level=levelTxt
              }
              this.DataList=dataList
              this.page =1
            }  
            else{
              Message.error('没有搜索到该试题')
            }
        })
        this.DataList=dataList
      },
  },
  mounted(){
    var url =this.HOME
    var moveL=[]
    var data={
      service:'Examination.ExamInfo',
      id:this.id,
      limit:this.limit,
      page:this.page,
      userid:localStorage.getItem('userid')
    }
    var List={
      service:'Examination.Examall',
    }
    var dataList=[]
   this.$axios.post(url,this.$qs.stringify(data))
      .then(res=>{
        if(res.data.data.code==405){
          this.alertView.failView(res.data.data.msg)
          this.$router.go(-1)
          return false
        }
        this.title=res.data.data.title
        this.count=parseInt(res.data.data.count)
        for(let i=0 ;i <res.data.data.info.length;i++){
          dataList.push(res.data.data.info[i])
          if(res.data.data.info[i].level==1){
            var levelTxt='简单'
          }
          else if(res.data.data.info[i].level==2){
            var levelTxt='一般'
          }
          else if(res.data.data.info[i].level==3){
            var levelTxt='较难'
          }
          else{
            var levelTxt='困难'
          }
          dataList[i].level=levelTxt
        }
        this.DataList=dataList
      })
        .catch(function (error) { // 请求失败处理
          console.log(error)
      });  
    this.$axios.post(url,this.$qs.stringify(List))
      .then(res=>{
       for(let i=0 ;i <res.data.data.info.length;i++){
          moveL.push(res.data.data.info[i])
        }
        this.moveList=moveL
      })
  }
}
</script>

<style>
@import "../assets/css/examManeger.css";
</style>



// WEBPACK FOOTER //
// src/components/detailsque.vue